<template>
  <div>
    <div class="font-medium text-lg" v-html="department.teaser"></div>

    <div class="sm:grid grid-cols-1 md:grid-cols-2 mt-6 sm:mt-16">
      <topic-index></topic-index>
      <div class="font-normal" v-html="department.content"></div>
    </div>

    <pre v-if="debug" class="mt-24">
    {{ department }}
    </pre>

  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import TopicIndex from '../components/topic_index.vue'

export default {
  data() {
    return {
      debug: false
    }
  },
  computed: {
    ...mapState(['department']),
    ...mapGetters(['department_topics'])
  },
  components: {
    TopicIndex
  }
}
</script>